import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {Button, Tooltip} from "@mui/material";
import CellCheckbox from "../../../сheckbox/CellCheckbox";
import {Link, useLocation} from "react-router-dom";
import ModalPerformRefund from "./ModalPerformRefund";
import ModalConfirm from "../../../modal/ModalConfirm";
import IssuingEdgeItemService
    from "../../../../../API/orders/prodaction.issueedge/issuingedgeitem/IssuingEdgeItemService";
import {EditLocalStoragePagesData} from "../../../../../utils/EditLocalStoragePagesData";
import MenuItem from "@mui/material/MenuItem";

const IssuingEdgesItemTable = ({id, change, setChange, handleModalAlert, loading, setLoading}) => {
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const [confirmModal, setConfirmModal] = useState(false)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const tableOptions = pagesData[`${pathname}+3`]?.tableOptions
        tableOptions && setTableOptions((prev) => ({...prev, pageSize: tableOptions.pageSize}))
    }
    const tableOptionsHandle = (nextState, currTab) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+3`, "tableOptions", nextState)
        }
    }

    useEffect(() => {
        getStartPageSize()
        IssuingEdgeItemService.getAllByIssuingEdgeId(id).then(function (response) {
            let data = response.data;
            setData(data)
            setTableOptions((prev) => ({...prev, totalElements: data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [change]);

    const [performRefundModalOpen, setPerformRefundModalOpen] = useState(false);
    const [refund, setRefund] = useState(null);

    const [closeModalOpen, setCloseModalOpen] = useState(false);

    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [currentRowIndex, setCurrentRowIndex] = useState(null);
    const [currentEditRowId, setCurrentEditRowId] = useState(null);


    const handleSubmitPerformRefund = () => {
        IssuingEdgeItemService.performRefund(currentEditRowId, id, refund).then(function (response) {
            setData(prevState => prevState.map(el => el.id === currentEditRowId ? response.data : el))
            closePerformRefundModalOpen();
            setChange(!change)
            handleModalAlert("Матнриал возвращён", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    };
    const handleSubmitOpenIssuing = () => {
        setLoading(true)

        IssuingEdgeItemService.openIssuingEdgeItem(currentEditRowData.id).then(function (response) {
            setConfirmModal(false)
            handleModalAlert("Выдача открыта", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error, 'error')
            })
            .finally(() => setLoading(false))
    }

    const handleSubmitCloseIssuingEdgeItem = () => {
        IssuingEdgeItemService.closeIssuingEdgeItem(currentEditRowId).then(function (response) {

            setData(prevState => prevState.map(el => {

                return el.id === currentEditRowId ? response.data : el
            }))
            closeCloseModalOpen();
            handleModalAlert("Выдача зкрыта", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    };

    useEffect(() => {
        IssuingEdgeItemService.getAllByIssuingEdgeId(id).then(function (response) {
            const data = response.data;
            setData(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'materialOrganizationOption.name',
                header: 'Наименование материала',
                accessorKey: 'materialOrganizationOption.name',
                minSize: 700,
            },
            {
                id: 'totalNeed',
                header: 'Необходимо',
                accessorKey: 'totalNeed',
                maxSize: 25,
            },
            {
                id: 'totalCount',
                header: 'Выдано',
                accessorKey: 'totalCount',
                maxSize: 25,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return <Link
                        to={'/organization/issuance-issuing-edges-item/' + row.original.id}>{value === null || value === undefined ? 0 : value.toFixed(2)}</Link>

                },
            },
            {
                id: 'overspending',
                header: 'Перерасход',
                accessorKey: 'overspending',
                maxSize: 25,
                Cell: ({cell}) => {
                    const value = cell.getValue();
                    return <Box sx={{
                        color: (theme) => value < 0 ? theme.palette.success.main : theme.palette.error.main
                    }}>{value === null || value === undefined ? 'Ожидание' : value.toFixed(2)}</Box>
                }
            },
            {
                id: 'closed',
                header: 'Закрыто',
                accessorKey: 'closed',
                maxSize: 25,
                Cell: ({cell, row}) => <CellCheckbox
                    cell={cell}
                    disabled={true}
                />,
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
                size: 2,
                maxSize: 2,
            },
        ];

        return baseColumns;
    }, [data, setData]);


    const closePerformRefundModalOpen = () => {
        setCurrentRowIndex(null)
        setCurrentEditRowData(null);
        setCurrentEditRowId(null);
        setPerformRefundModalOpen(false)
    };

    const closeCloseModalOpen = () => {
        setCurrentRowIndex(null)
        setCurrentEditRowData(null);
        setCurrentEditRowId(null);
        setCloseModalOpen(false)
    };

    const handlePerformRefund = useCallback(
        (row) => {
            setCurrentRowIndex(row.id)
            setCurrentEditRowData(row);
            setCurrentEditRowId(row.id);
            setRefund(row.totalCount);
            setPerformRefundModalOpen(true)
        },
        [data, currentEditRowData, setCurrentEditRowData],
    );

    const close = useCallback(
        (row) => {
            setCurrentRowIndex(row.id)
            setCurrentEditRowData(row);
            setCurrentEditRowId(row.id);
            setCloseModalOpen(true)
        },
        [data, currentEditRowData, setCurrentEditRowData],
    );
    const handleIssuingOpen = (row) => {
        setCurrentEditRowData(row)
        setConfirmModal(true)
    }
    const menuItem = [
        {type: "return", text: "Выполнить возврат", handler: handlePerformRefund},
        {type: "close", text: "Закрыть выдачу", handler: close},
        {type: "issuingOpen", text: "Открыть выдачу", handler: handleIssuingOpen}
    ]

    return (
        <Box sx={{width: '1500px',}}>
            <Box
                sx={{display: 'flex', justifyContent: "flex-end"}}
            ></Box>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                muiTableContainerProps={{
                    sx: {
                        width: '1500px',
                    }
                }}
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        border: "none",
                        "&:after": {
                            display: "none",
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',

                        },
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        },
                        "&:first-of-type": {
                            padding: 0,
                            width: "50px",
                            height: "36px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: (theme) => theme.palette.text.light,
                            "& .MuiButtonBase-root": {
                                borderRadius: "4px",
                                width: "24px",
                                height: "24px",
                                opacity: 1,
                                margin: 0,
                                padding: 0,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                }
                            }
                        },

                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem"
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}

                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 3,
                        minSize: 3,
                        grow: false,
                    },
                }}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                columns={columns}
                data={data}
                rowHeight={13}
                columnSpacing={1}
                initialState={{
                    columnVisibility: {
                        id: false,
                    },
                    isFullScreen: false,
                    density: "compact",
                }}
                localization={MRT_Localization_RU}
                enableToolbarInternalActions={false}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                rowCount={tableOptions.totalElements}
                state={{showGlobalFilter: true, pagination: tableOptions,}}
                enableRowActions={true}
                getRowId={(originalRow) => originalRow.id}
                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                    const active = el.type === "issuingOpen"
                        ? row.original.closed
                        : !row.original.closed
                    return <Tooltip arrow placement="left"
                                    title={!active ? "заблокировано" : ""}>
                        <MenuItem
                            key={el.type}
                            onClick={() => {
                                active && el.handler(row.original)
                                closeMenu();
                            }}
                            sx={{
                                margin: "0 8px",
                                borderRadius: "4px",
                                opacity: !active && 0.5,
                                "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                            }}
                        >
                            {el.text}
                        </MenuItem>
                    </Tooltip>
                })}
            />
            <ModalPerformRefund
                open={performRefundModalOpen}
                onClose={closePerformRefundModalOpen}
                titleModal={"Вернуть материал в количестве"}
                issue={currentEditRowData ? currentEditRowData.totalCount : null}
                refund={currentEditRowData ? currentEditRowData.totalCount : null}
                setRefund={setRefund}
                submit={handleSubmitPerformRefund}
            />
            <ModalConfirm
                title={"Подтвердить закрыть выдачу?"}
                modalOpen={closeModalOpen}
                handleClose={closeCloseModalOpen}
                handleSubmit={handleSubmitCloseIssuingEdgeItem}
                action={"Подтвердить"}
            />
            <ModalConfirm
                title={"Подтвердить открыть выдачу"}
                modalOpen={confirmModal}
                handleClose={() => setConfirmModal(false)}
                handleSubmit={handleSubmitOpenIssuing}
                action={"Подтвердить"}
                loading={loading}
            />
        </Box>
    );
};

export default IssuingEdgesItemTable;